'use client';

import { __assign } from '../_virtual/_tslib.js';

var TextEditorUtils = {
    getTextFromStringyContentState: function (content) {
        // Content could be escaped, e.g. the quote replaced by '&#34;', so we need to unescape it
        var unEscapedContent = content.replace(/&#34;/gi, '"');
        var isRawContentState = this.checkRawDraftContentState(unEscapedContent);
        if (isRawContentState) {
            try {
                var contentObject = JSON.parse(unEscapedContent);
                return contentObject.blocks.map(function (block) { return block.text; }).join('\n');
            }
            catch (error) {
                console.info('Error paring JSON', error);
                console.info('JSON to parse:', unEscapedContent);
            }
        }
        return unEscapedContent.trim();
    },
    checkRawDraftContentState: function (content) {
        var objectRegex = /^{.*}$/gi;
        var thisIsAnObject = !!content.match(objectRegex);
        return thisIsAnObject && content.includes('blocks') && content.includes('entityMap');
    },
    convertDraftRawContentToHTML: function (content, draftToHtml) {
        var unEscapedContent = content.replace(/&#34;/gi, '"');
        var isRawDraftContentState = this.checkRawDraftContentState(unEscapedContent);
        // If this is a raw draft content state
        if (isRawDraftContentState) {
            try {
                var rawContentState = JSON.parse(unEscapedContent);
                /**
                 * VNW-18264 Lost word when input special characters
                 * when type of rawContentState is article, draftToHtml return wrong
                 *
                 * @author Tran Minh Tri
                 * @since Oct 5, 2022
                 */
                rawContentState = __assign(__assign({}, rawContentState), { blocks: rawContentState.blocks.map(function (item) {
                        if (item.type === 'article')
                            return __assign(__assign({}, item), { type: 'unstyled' });
                        else
                            return item;
                    }) });
                var markup = draftToHtml(rawContentState);
                // Extra processes for some cases that `draftToHtml` does not work well
                var processedMarkup = markup
                    .replace(/\n/gi, '') // Remove \n
                    .replace(/<ins>/g, '<u>')
                    .replace(/<\/ins>/g, '</u>')
                    .replace(/<.?><img .*?><\/.?>/g, '') // Remove img tag inside any tag
                    .replace(/<img .*?>/g, ''); // Remove img tag
                var removedHTMLTag = processedMarkup.replace(/<\/?[^>]*>/g, '');
                if (removedHTMLTag === '') {
                    return removedHTMLTag;
                }
                return processedMarkup;
            }
            catch (error) {
                console.info('Error paring JSON', error);
                console.info('JSON to parse:', unEscapedContent);
            }
        }
        // Otherwise, it's might be html
        return unEscapedContent;
    }
};

export { TextEditorUtils as default };
//# sourceMappingURL=textEditorUtils.js.map
